import React from 'react';

import { IFullwidthHero20Fields } from '../../../types/contentful';

import MobileView from './Viewports/MobileView';
import DesktopView from './Viewports/DesktopView';
import { usePageDataContext } from '~/context/PageData';

export function FullwidthHero(props: IFullwidthHero20Fields) {
  const { isReturning } = usePageDataContext();

  return (
    <>
      <DesktopView {...props} isReturning={isReturning} />
      <MobileView {...props} isReturning={isReturning} />
    </>
  );
}
